import { gql } from "@apollo/client";

export const GET_APP_SETTINGS = gql`
  query {
    getAppVersion {
      appVersions {
        version
        platform
        forceUpdatable
      }
    }
  }
`;

export const UPDATE_APP_SETTINGS = gql`
  mutation updateAppVersion($updateAppVersionInput: UpdateAppVersionInput!) {
    updateAppVersion(updateAppVersionInput: $updateAppVersionInput) {
      appVersions {
        version
        platform
        forceUpdatable
      }
    }
  }
`;
